// VoiceBarIcons.jsx — inline SVG icons for the microphone / text / speaker bar.
// Source of truth for the artwork: docs/2.03/gds/images/svg/. Strokes use currentColor, so the
// icons never carry an agent color: the bar decides the color, the icons follow it.
import React from 'react';

const MIC_PATHS = (
  <>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M12 18v3" />
    <path d="M8.5 21h7" />
  </>
);

const Svg = ({ children, size = 24, label, fill = 'none', ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill={fill}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    role={label ? 'img' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const MicIcon = (props) => <Svg {...props}>{MIC_PATHS}</Svg>;

export const MicOffIcon = (props) => (
  <Svg {...props}>
    {MIC_PATHS}
    <path d="M4 4l16 16" />
  </Svg>
);

// Mic with a small ban badge at the lower right. The badge is cut out of the mic with the
// bar's own background (--bar-bg, set by the bar), so it reads on the charcoal band.
export const MicBlockedIcon = (props) => (
  <Svg {...props}>
    <g transform="translate(-1.5 -1.5) scale(.82)">{MIC_PATHS}</g>
    <circle cx="17.5" cy="17.5" r="5" fill="var(--bar-bg, #2c2b2b)" />
    <circle cx="17.5" cy="17.5" r="4" />
    <path d="M14.7 20.3l5.6-5.6" />
  </Svg>
);

export const SpeakerIcon = (props) => (
  <Svg {...props}>
    <path d="M4 9v6h4l5 4V5L8 9H4z" />
    <path d="M16 9a4 4 0 0 1 0 6" />
    <path d="M18.5 6.5a8 8 0 0 1 0 11" />
  </Svg>
);

export const SpeakerOffIcon = (props) => (
  <Svg {...props}>
    <path d="M4 9v6h4l5 4V5L8 9H4z" />
    <path d="M17 9l5 6" />
    <path d="M22 9l-5 6" />
  </Svg>
);

export const ArrowUpIcon = (props) => (
  <Svg {...props}>
    <path d="M12 19V5" />
    <path d="M6 11l6-6 6 6" />
  </Svg>
);

export const StopIcon = (props) => (
  <Svg {...props} fill="currentColor" stroke="none">
    <rect x="7" y="7" width="10" height="10" rx="2" />
  </Svg>
);
